import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PushCameraService } from '../../api/gen/api/pushCamera.service';
import { ItcPushService } from '../../api/gen/api/itcPush.service';
import { JjamesButtonComponent } from 'shared-lib';

@Component({
  selector: 'app-testing-push',
  templateUrl: './testing-push.component.html',
  styleUrl: './testing-push.component.scss',
  standalone: true,
  imports: [CommonModule, FormsModule, JjamesButtonComponent]
})
export class TestingPushComponent {
  pushCameraId = '';
  pushCameraPayload = '';
  pushCameraResult = '';

  itcGateId?: number;
  itcIp = '';
  itcDirection = '';
  itcPayload = '';
  itcPushResult = '';

  private pushCameraService = inject(PushCameraService);
  private itcPushService = inject(ItcPushService);

  testPushCamera() {
    this.pushCameraResult = '';
    let payload: any = undefined;
    try {
      payload = this.pushCameraPayload ? JSON.parse(this.pushCameraPayload) : undefined;
    } catch (e) {
      this.pushCameraResult = 'Invalid JSON payload.';
      return;
    }
    this.pushCameraService.cameraCameraIdPushPost(this.pushCameraId, payload).subscribe({
      next: (res) => {
        this.pushCameraResult = 'Success: ' + JSON.stringify(res);
      },
      error: (err) => {
        this.pushCameraResult = 'Error: ' + JSON.stringify(err);
      }
    });
  }

  testItcPush() {
    this.itcPushResult = '';
    let body: any = undefined;
    try {
      body = this.itcPayload ? JSON.parse(this.itcPayload) : undefined;
    } catch (e) {
      this.itcPushResult = 'Invalid JSON payload.';
      return;
    }
    this.itcPushService.apiItcpushPost(
      this.itcGateId,
      this.itcIp,
      this.itcDirection,
      body
    ).subscribe({
      next: (res) => {
        this.itcPushResult = 'Success: ' + JSON.stringify(res);
      },
      error: (err) => {
        this.itcPushResult = 'Error: ' + JSON.stringify(err);
      }
    });
  }
}
